import React from 'react';
import TextField from 'material-ui/TextField';

const DescriptionStep = ({ fields, assignRef }) => (
  <div className="step-content">
    <h2>Lýsandi lýsing</h2>
    <p>
      Hér fær þinn innri rithöfundur tækifæri til að láta ljós sitt skína.<br />
      Reyndu samt að hafa lýsinguna stutta og hnitmiða, þú hefur bara 1000 stafabil til aflögu.
    </p>
    <div className="input-wrapper columns description">
      <TextField
        {...fields.description}
        ref={assignRef ? c => assignRef('description', c) : null}
        floatingLabelText="Sláðu hér inn lýsingu"
        multiLine fullWidth rows={8} maxLength={1000}
      />
      <span className="word-count">{fields.description.value.length} / 1000</span>
    </div>
  </div>
);

DescriptionStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  assignRef: React.PropTypes.func,
};

export default DescriptionStep;



// WEBPACK FOOTER //
// ./src/browser/steps/DescriptionStep/DescriptionStep.js